import {config} from '../config';

export default {
    getScpApiUrl: () => config.data.scp.scpApiUrl,
    getScpCloudTopicMarket: () => config.data.scp.scpCloudTopicMarket,
    getScpCloudTopicMarketPrefix: () => config.data.scp.scpCloudTopicMarketPrefix,
    getScpCloudVersion: () => config.data.scp.scpCloudVersion,
};
